<template>
  <div class="MakeItem">

    <AddProduct v-show="!actives" @isAddProduct="isAddProduct" @listAddProduct="listAddProduct" :plusItemList.sync="info_form.plusItemList" :price.sync="price" />

    <div class="main" v-show="actives">

      <div class="make" v-if="isMake">
        <p class="make_titile">预约</p>
        <van-radio-group @change="radioChange" v-model="info_form.appointFlag" direction="horizontal">
          <van-radio :name="true">现在预约</van-radio>
          <van-radio :name="false">以后预约</van-radio>
        </van-radio-group>
      </div>

      <div class="main_content">

        <div>
          <div class="title">
            <p>基本信息</p>
          </div>
          <div class="info_form">
            <van-form ref="info_form" :disabled="info_form_disabled" @submit="onSubmit" :show-error="false" label-width="80" >
              <van-field
                  v-model="info_form.patientName"
                  name="patientName"
                  label="体检人姓名"
                  maxlength="10"
                  placeholder="请输入体检人姓名"
                  :rules="[{ required: true, message: '请填写体检人姓名' }]"
              >
                <template #right-icon>
                  <div class="icon" @click=" ( info_form.appointFlag ? clickSee() : '' ) ">
                    <i class="iconfont icon-jiaren"></i>
                    <p>选择</p>
                  </div>
                </template>
              </van-field>
              <van-popup v-model="SeeshowPicker" position="bottom">
                <van-picker
                    show-toolbar
                    value-key="patientName"
                    :columns="See"
                    @confirm="onConfirmSee"
                    @cancel="SeeshowPicker = false"
                />
              </van-popup>


              <van-field
                  v-model="info_form.idCardNo"
                  name="idCardNo"
                  label="身份证号"
                  placeholder="请输入体检人身份证号"
                  :rules="[{ required: true, message: '请填写体检人身份证号' },{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号不正确' }]"
              />

              <van-field name="radio" label="性别">
                <template #input>
                  <div v-if="info_form.gender == 0" style="width: 100%; display: flex; justify-content: flex-start;">
                    女
                  </div>
                  <div v-else-if="info_form.gender == 1" style="width: 100%; display: flex; justify-content: flex-start;">
                    男
                  </div>
                  <div v-else style="width: 100%; display: flex; justify-content: flex-end;">
                    {{ info_form.gender }}
                  </div>
                </template>
              </van-field>

              <van-field
                  v-model="info_form.phoneNo"
                  name="phoneNo"
                  label="手机号"
                  placeholder="请输入体检人手机号"
                  :rules="[{ required: true, message: '请填写体检人手机号' },{ pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/, message: '体检人手机号不正确' }]"
              />

              <van-field
                  readonly
                  clickable
                  name="relationship"
                  :value=" ( info_form.relationship ? this.$store.state.rela.filter((item) => { return item.dictKey == info_form.relationship })[0].dictValue : '' )"
                  label="与本人关系"
                  placeholder="请选择与本人的关系"
                  @click="( info_form_disabled ? '' : showPickerRela = true )"
                  :rules="[{ required: true, message: '请选择与本人的关系' }]"
              >
                <template #right-icon>
                  <i class="iconfont icon-tiaozhuan" style="color: #3390F3; "></i>
                </template>
              </van-field>
              <van-popup v-model="showPickerRela" position="bottom">
                <van-picker
                    show-toolbar
                    value-key="dictValue"
                    :columns="this.$store.state.rela"
                    @confirm="onConfirmRela"
                    @cancel="showPickerRela = false"
                />
              </van-popup>

            </van-form>
          </div>
        </div>

        <div>
          <div class="title">
            <p>预约服务</p>
          </div>
          <div class="services">
            <van-collapse v-model="activeNames">

              <van-collapse-item v-for="(item,index) in data_list" :key="index" :title="item.productCategoryName" :name="item.productId">

                <van-form :disabled="info_form_disabled" :ref="'form'+index" @submit="onSubmit" :show-error="false" label-width="60" >

                  <van-field
                      class="grey_input"
                      readonly
                      clickable
                      name="appointmentDate"
                      :value="(item.appointmentStartDate ? item.appointmentStartDate + ' 至 ' + item.appointmentEndDate : null )"
                      label="预约日期"
                      placeholder="请选择预约日期"
                      @click="( info_form_disabled ? '' : item.showPickerDate = true )"
                      :rules="[{ required: true, message: '请选择预约日期' }]"
                  >
                    <template #right-icon>
                      <div>
                        <p class="iconfont icon-xuanzeriqi"></p>
                      </div>
                    </template>
                  </van-field>
                  <van-calendar v-model="item.showPickerDate"
                                :default-date="null"
                                :min-date="minDate"
                                type="range"
                                :show-confirm="false"
                                @confirm="onConfirmDate($event,item)" >
                  </van-calendar>
<!--                  <van-popup v-model="item.showPickerDate" position="bottom">-->
<!--                    <van-datetime-picker-->
<!--                        type="date"-->
<!--                        title="选择年月日"-->
<!--                        :min-date="minDate"-->
<!--                        @confirm="onConfirmDate($event,item)"-->
<!--                        @cancel="item.showPickerDate = false"-->
<!--                    />-->
<!--                  </van-popup>-->

                  <van-field
                      class="grey_input"
                      readonly
                      clickable
                      name="appointmentPeriod"
                      :value="( item.appointmentPeriod ? item.periodDict.filter((items) => { return items.dictKey == item.appointmentPeriod })[0].dictValue : '' )"
                      label="预约时段"
                      placeholder="请选择预约时段"
                      @click="(info_form_disabled ? '' : item.showPickerTime = true )"
                      :rules="[{ required: true, message: '请选择预约时段' }]"
                  >
                    <template #right-icon>
                      <div>
                        <p :class="( item.showPickerTime ? 'icon-shangxiaxuanze-zhuan' : '' )"  class="iconfont icon-shangxiaxuanze"></p>
                      </div>
                    </template>
                  </van-field>
                  <van-popup v-model="item.showPickerTime" position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="dictValue"
                        :columns="item.periodDict"
                        @confirm="onConfirmTime($event,item)"
                        @cancel="item.showPickerTime = false"
                    />
                  </van-popup>

                  <van-field
                      :class="( item.hospitalDict.length == 1 ? '' : 'grey_input' )"
                      readonly
                      clickable
                      name="picker"
                      :value="( item.appointmentHospital ? item.hospitalDict.filter((items) => { return items.dictKey == item.appointmentHospital })[0].dictValue : '' )"
                      label="预约地点"
                      placeholder="请选择预约地点"
                      :rules="[{ required: true, message: '请选择预约地点' }]"
                      :disabled="item.hospitalDict.length == 1 || info_form_disabled"
                      @click="(item.hospitalDict.length == 1 || info_form_disabled ? '' : item.showPickerHospital= true )"
                  >
                    <template #right-icon>
                      <div v-if="item.hospitalDict.length != 1">
                        <p class="iconfont icon-shangxiaxuanze" :class="( item.showPickerHospital ? 'icon-shangxiaxuanze-zhuan' : '' )" ></p>
                      </div>
                    </template>
                  </van-field>
                  <van-popup v-model="item.showPickerHospital" position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="dictValue"
                        :columns="item.hospitalDict"
                        @confirm="onConfirmHospital($event,item)"
                        @cancel="item.showPickerHospital = false"
                    />
                  </van-popup>

                </van-form>

              </van-collapse-item>

            </van-collapse>
          </div>
        </div>

        <div>
          <div class="title" @click="link_deta()" >
            <p>{{ $route.query.name }} 包含项目详情</p>
            <div class="title_right">
<!--              <p>￥{{ $route.query.price }}</p>-->
              <i class="iconfont icon-weibiaoti25"></i>
            </div>
          </div>
          <div class="be_careful" v-for="(item,index) in data_list" :key="index">
            <template>
              <h2 v-if="item.productCategory == '0'">体检注意事项</h2>
              <p v-if="item.productCategory == '0'">
                体检是人们做好预防保健工作的一项重要举措。在进行体检时，应注意以下几项：<br/>
                1.体检前必须空腹，应在体检前一晚10:00过后禁食，可以饮水，但是不能喝牛奶、豆浆等含有糖分的饮料。检查当天需抽完血、做完腹部超音波检查后，方可进食。<br/>
                2.体检前3天不要大鱼大肉，忌酒，不要吃过于油腻的高蛋白、高脂肪的食物，也不要过于剧烈的活动，会导致体检的结果出现偏差。避免使用对肝肾功能有影响的药物。<br/>
                3.体检时要着穿脱方便的服装、鞋袜，最好不佩戴项链等，女同志的文胸不要带钢托，不要穿金属亮片的内衣。。<br/>
                4.女士生理期，不宜作妇科检查及尿检;做妇科检查前应排空膀胱;乳腺远红外线复查最好选择在生理期后一周内。未婚女士不宜做妇科检查,有特殊需求者要签署相关协议(告知书)方可进行相应检查。<br/>
                5.做膀胱、前列腺、子宫、附件B超时，需要憋排尿。<br/>
                6.为避免血压波动发生危险，高血压患者应在服完降压药后再来体检。糖尿病或其他慢性病患者，也应在采血后及时服药，不可因体检而干扰常规治疗。<br/>
              </p>
              <h2 v-if="item.productCategory == '1'">胃肠镜注意事项</h2>
              <p v-if="item.productCategory == '1'">
                胃镜检查注意事项：<br/>
                1.体检者应该查乙肝表面抗原、胸片、心电图等，如果有严重的心肺疾病，不建议做胃镜检查。<br/>
                2.胃镜需要空腹检查，检查前一天的饮食以清淡饮食为主，检查前半个小时左右尽量不要喝水。<br/>
                3.糖尿病患者可以带一些糖块类食物，防止出现低血糖。心脏病、高血压的患者，要在医生的指导下，停用抗凝药一段时间，让凝血功能恢复到大致正常，再做胃镜查。<br/>
                4.胃镜检查过程中要按医嘱进行吞咽动作，可以有效的缓解恶心干呕等反应。<br/>
                5.检查后，半小时内不要喝水和吃东西，避免引起呛咳。当天宜清淡饮食，忌辛辣，次日可以恢复正常的饮食，但还是尽量避免坚硬、刺激性食物。<br/>
                6.胃镜后尽量卧床休息两到三个小时， 24小时内不能做剧烈运动。<br/>
                肠镜检查注意事项:<br/>
                1.检查前3天，进食低脂少渣饮食（如稀饭、面条、蒸鸡蛋等）。避免食用水果、蔬菜、全谷类和肉类。<br/>
                2.检查前2天，不要吃深色食物，避免影响肠镜观察。<br/>
                3.肠镜检查前需要禁食8小时、禁饮6小时。因此，检查前1晚进食清流质饮食后，就不能吃任何东西了。<br/>
                4.检查前一晚进行肠道准备工作，按医嘱服用泻药，使排出的粪便为清亮水样、无明显粪渣的状态。<br/>
                5.高血压病人，需服用降压药使血压正常。服用抗凝药物者需要提前告知医生。<br/>
                6.检查时需要穿宽松的衣裤。<br/>
                7.女性在经期需要谨慎，告知医生，由医生决定是否进行肠镜。<br/>
                8.检查后，若无腹痛、腹胀，可进食易消化的食物。如腹痛、腹胀明显，持续不能缓解或进行性加重，请您立即告知医生。<br/>
                9.如做了病理学检查或手术，需要卧床休息，3天内避免剧烈运动，1周内避免负重。<br/>
              </p>

            </template>
          </div>
        </div>

      </div>

    </div>

    <div class="footer">
      <mu-button v-if="actives && !isMakeOrder && listAddProducts.length!= 0" @click="previous" color="primary" round >上一页</mu-button>
      <p>¥ {{ price }}</p>
      <mu-button v-if="!actives" @click="next" color="primary" round >下一页</mu-button>
      <div v-if="actives" >
        <mu-button @click="onSubmit" :disabled="loading1" v-loading="loading1" data-mu-loading-size="12"
                   v-if="isMake || info_form.plusItemList.length !== 0" round color="primary">立即支付</mu-button>
        <mu-button @click="onSubmit" :disabled="loading1" v-loading="loading1" data-mu-loading-size="12"
                   v-else round color="primary">立即预约</mu-button>
      </div>
    </div>

    <van-popup class="success_popup" v-model="show" :close-on-click-overlay="false">

      <div class="popup" v-if="info_form.appointFlag">
        <h2>预约提交成功</h2>
        <p>
          客服人员会尽快和您联系<br/>
          确认最终体检时间<br/>
          请耐心等待<br/>
        </p>
        <mu-button color="primary" round @click="return_index" >返回首页</mu-button>
      </div>

      <div class="popup" v-else >
        <h2>购买成功</h2>
        <p>
          请您及时预约
        </p>
        <mu-button color="primary" round @click="return_index" >返回首页</mu-button>
      </div>

    </van-popup>

<!--    抽屉-->
    <mu-drawer width="70%" :open.sync="open" :docked="false" :right="'right'">
      <div class="drawer">

        <div class="drawer_title">
          包含项目
        </div>

        <ul class="meal">
          <li class="meal_li" v-for="(item,index) in item_list" :key="index" >
            <template>
              <h2 v-if="item.productCategory == 0" class="title">体检套餐</h2>
              <h2 v-if="item.productCategory == 1" class="title">胃肠道筛查套餐</h2>
              <h2 v-if="item.productCategory == 2" class="title">整合式筛查套餐</h2>
              <h2 v-if="item.productCategory == 3" class="title">锦医未</h2>
            </template>
            <ul class="main_tab_deta">
              <li v-for="(items,indexs) in item.itemList" :key="indexs" >
                <h2>{{ items.itemName }}</h2>
                <p>{{ items.itemDesc }}</p>
              </li>
            </ul>
          </li>
        </ul>

      </div>
    </mu-drawer>


  </div>
</template>

<script>

import AddProduct from "@/components/Make/AddProduct";

// 预约单品 prepayId
export default {
  name: "MakeSetMeal",
  data() {
    return{
      info_form: {
        appointFlag: true, // 是否预约
        patientName: null, // 患者姓名
        phoneNo: null, // 手机号
        relationship: null, // 与本人关系
        idCardNo: null, // 身份证号
        gender: "--", // 性别
        plusItemList: [], // 附加项列表
        productId: this.$route.query.id, // 产品ID
        cardNo: ( this.$route.query.cardNo ? this.$route.query.cardNo : null ), // 卡号
        orderNo: ( this.$route.query.orderNo ? this.$route.query.orderNo : null ), // 订单ID
        prepayId: ( this.$route.query.prepayId ? this.$route.query.prepayId : null ), // 预支付ID
        fromUserId: ( this.$route.query.fromUserId ? JSON.parse(this.$route.query.fromUserId) ? this.$route.query.fromUserId : null : null ), // 分享UserId
      },
      activeNames: ["1","2"],
      minDate: new Date(),
      // 预约成功
      show: false,
      // 支付/预约
      isMake: null,
      // 就诊人选择器
      SeeshowPicker: false,
      See: [],
      // 与本人关系选择器
      showPickerRela: false,
      // 预约数据
      data_list: [],
      // 禁用
      info_form_disabled: false,
      payJson: null,
      // 金额
      price: this.$route.query.price,
      // 抽屉
      open: false,
      // 包含项目
      item_list: [],
      loading1: false,
      // 状态
      isMakeOrder: this.$route.query.isMakeOrder ? this.$route.query.isMakeOrder : false,
      actives: 0,
      listAddProducts: []
    }
  },
  watch:{
    info_form: {
      handler(newVal) {
        if(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(newVal.idCardNo)) {
          if((newVal.idCardNo[newVal.idCardNo.length-2] % 2) == 0 ) {
            this.info_form.gender= 0;
          }else {
            this.info_form.gender= 1;
          }
        }else {
          this.info_form.gender= "--";
        }
      },
      deep: true
    },
    '$store.state.wxapy'(newValue) {
      let pay = newValue;
      if(pay == 0) {
        this.show= true;
        this.$store.commit("setWxapy",null)
      }else if(pay == 1) {
        this.$dialog.confirm({
          message: '即将完成预约，是否离开？',
          confirmButtonText: "继续支付",
          cancelButtonText: "残忍离开"
        })
            .then(() => {
              // on confirm
              this.$wxPay(this.payJson);
            })
            .catch(() => {
              this.$router.push({
                path: "/OrderList",
                query: {
                  active: 0
                }
              })
              // on cancel
            });
        this.$store.commit("setWxapy",null)
      }else if(pay == 2) {
        this.$store.commit("setWxapy",null)
      }else {
        this.$store.commit("setWxapy",null)
      }
    },
  },
  created() {
    this.$isIos();

    // 日期
    this.minDate=this.minDate.setDate(this.minDate.getDate()+2);
    this.minDate=new Date(this.minDate);

    if(this.$route.query.isMake) {
      this.isMake= JSON.parse(this.$route.query.isMake);
    }else {
      this.isMake= false;
    }

    document.title= this.$route.query.name + "预约";

    // 获取与本人关系
    this.$store.dispatch("setRela");
    // 获取包含项目
    this.get_item(this.info_form.productId);
    // 获取预约数据
    this.get_data(this.$route.query.id);



  },
  mounted() {

  },
  methods: {
    listAddProduct(e) {
      this.listAddProducts= e;
    },
    isAddProduct(e) {
      this.actives= e;
    },
    // 下一页
    next() {
      this.actives= 1;
    },
    // 上一页
    previous() {
      this.actives= 0;
    },
    // 待支付订单预约数据
    get_order(y) {
      this.$get("order/appoint",y)
       .then(res => {
         if(res) {

           this.info_form.idCardNo= res.data.idCardNo;
           this.info_form.patientName= res.data.patientName;
           this.info_form.phoneNo= res.data.phoneNo;
           this.info_form.relationship= res.data.relationship;

           if( res.data.appointmentInfoList != null && res.data.appointmentInfoList.length != 0) {
             this.data_list.forEach((item,index) => {
               this.data_list[index].appointmentDate= res.data.appointmentInfoList[index].appointmentDate;
               this.data_list[index].appointmentHospital= res.data.appointmentInfoList[index].appointmentHospital.toString();
               this.data_list[index].appointmentPeriod= res.data.appointmentInfoList[index].appointmentPeriod;
             })
           }

         }
       })
    },
    // 获取包含项目
    get_item(y) {
      this.$get("product/"+ y +"/item")
        .then(res => {
          if(res) {
            // console.log(res.data);
            this.item_list= res.data;
          }
        })
    },
    clickSee() {
      if(this.See.length != 0) {
        this.SeeshowPicker= true;
      }else {
        this.$dialog.confirm({
          message: '暂无就诊人,是否去添加就诊人',
        })
            .then(() => {
              // on confirm

              this.$router.push({
                path: "/InfoList"
              })

            })
            .catch(() => {
              // on cancel
            });
      }
    },
    // 获取预约数据
    get_data(e) {
      this.$get("appointment/data",e,true)
        .then(res => {
          if(res) {
            console.log(res.data)
            res.data.forEach((item)=> {
              item["showPickerDate"]= false;
              item["showPickerTime"]= false;
              item["showPickerHospital"]= false;

              if(item.productCategory == 0) {
                item["productCategoryName"] = "体检套餐";
              }else if(item.productCategory == 1) {
                item["productCategoryName"] = "胃肠道筛查套餐";
              }else if(item.productCategory == 2) {
                item["productCategoryName"] = "整合式筛查套餐";
              }else if(item.productCategory == 3) {
                item["productCategoryName"] = "锦医未";
              }

              if(item.hospitalDict.length == 1) {
                item.appointmentHospital= item.hospitalDict[0].dictKey;
              }

              this.activeNames.push(item.productId);

            })

            this.data_list= res.data;

            if(this.info_form.orderNo && this.isMake) {
              let obj ={};
              obj["orderNo"]= this.info_form.orderNo;
              this.get_order(obj);
            }

            // 获取就诊人选择器
            this.grt_see_list();

            // console.log(res.data);
          }
        })
    },
    // 选择预约日期
    onConfirmDate(e,item) {

      console.log(e)
      console.log(item)

      item.appointmentStartDate= this.formatDate(e[0]);
      item.appointmentEndDate= this.formatDate(e[1]);
      console.log(item);

      item.showPickerDate= false;
    },
    // 选择预约时段
    onConfirmTime(e,item) {
      item.appointmentPeriod= e.dictKey;
      item.showPickerTime= false;
    },
    // 选择预约医院
    onConfirmHospital(e,item) {
      item.appointmentHospital= e.dictKey;
      item.showPickerHospital= false;
    },
    // 获取就诊人选择器
    grt_see_list() {
      this.$get("patient/page")
        .then(res => {
          if(res) {
            this.See= res.data;
          }
        })
    },
    // 选择就诊人
    onConfirmSee(e) {
      console.log(e);
      this.info_form.gender= e.gender;
      this.info_form.patientName= e.patientName;
      this.info_form.phoneNo= e.phoneNo;
      this.info_form.relationship= e.relationship.toString();
      this.info_form.idCardNo= e.idCardNo;
      this.SeeshowPicker= false;
    },
    // 选择与本人关系
    onConfirmRela(e) {
      this.info_form.relationship= e.dictKey.toString();
      this.showPickerRela= false;
    },
    // 是否预约
    radioChange(e) {
      if(e) {
        this.info_form_disabled= false;
      }else {
        this.info_form_disabled= true;
        this.$refs.info_form.resetValidation();

        // this.data_list.forEach((item,index)=> {
        //   let str= "form" + index;
        //   this.$refs[str][0].resetValidation()
        // })

        // 置空
        // this.info_form.patientName= null; // 患者姓名
        // this.info_form.phoneNo= null; // 手机号
        // this.info_form.relationship= null; // 与本人关系
        // this.info_form.idCardNo= null; // 身份证号
        // this.info_form.gender= "--"; // 性别

        // 获取预约数据 置空
        // this.get_data(this.$route.query.id);
      }
    },
    // 提交
    onSubmit() {

      console.log(this.info_form);

      // 是否预约
      if(this.info_form.appointFlag) {
        this.$refs.info_form.validate()
            .then(()=> {
              this.data_list.forEach((item,index)=> {
                let str= "form" + index;
                this.$refs[str][0].validate()
                    .then(()=> {

                      if(index == this.data_list.length-1) {

                        let arr= [];
                        this.data_list.forEach((item)=> {
                          let obj= {};
                          // obj["appointmentDate"]= item.appointmentDate;
                          obj["appointmentStartDate"]= item.appointmentStartDate;
                          obj["appointmentEndDate"]= item.appointmentEndDate;
                          obj["appointmentHospital"]= item.appointmentHospital;
                          obj["appointmentPeriod"]= item.appointmentPeriod;
                          obj["productId"]= item.productId;
                          obj["appointType"]= item.productCategory;
                          arr.push(obj);
                        })

                        this.info_form["appointmentInfo"]= arr;
                        this.loading1= true;

                        if(this.isMake) {
                          if(this.info_form.prepayId) {
                            this.set_pay(this.info_form);
                          }else {
                            this.makeApi(this.info_form);
                          }
                        }else {
                          this.make(this.info_form);
                        }

                      }

                    })
              })
            })
      }else {
        console.log(this.info_form.prepayId);
        if(this.info_form.prepayId) {
          this.set_pay(this.info_form);
        }else {
          let obj= {};
          obj["appointFlag"]= this.info_form.appointFlag;
          obj["productId"]= this.info_form.productId;
          obj["plusItemList"]= this.info_form.plusItemList;
          if(this.info_form.fromUserId) {
            obj["fromUserId"]= this.info_form.fromUserId;
          }
          this.makeApi(obj);
        }
      }

    },
    // 待支付订单重新发起支付 -- 订单待支付购买
    set_pay(y) {
      this.$post("order/pay",y)
          .then(res => {
            this.loading1= false;
            if(res) {
              this.$store.commit("setWxapy",null)
              this.payJson= res.data;
              this.$wxPay(res.data)
            }
          })
          .catch(() => {
            this.loading1= false;
          })
    },
    // 产品购买下单 -- 正常下单购买
    makeApi(y) {
      this.$post("product/order/buy",y)
        .then(res => {
          this.loading1= false;
          if(res) {
            console.log(res);
            if(this.$route.query.isMake) {
              this.$store.commit("setWxapy",null)
              this.payJson= res.data;
              this.$wxPay(res.data)
            }
          }
        })
        .catch(() => {
          this.loading1= false;
        })
    },
    // 预约 -- 卡号预约 选择附加项则支付
    make(y) {
      this.$post("appointment",y)
        .then(res => {
          this.loading1= false;
          if(res) {

            console.log(res);
            if(res.data.needPay) {
              console.log("卡号预约选择附加项支付");
              this.$store.commit("setWxapy",null)
              this.payJson= res.data.wechatPayVO;
              this.$wxPay(res.data.wechatPayVO)
            }else {
              this.show= true;
            }

          }
        })
        .catch(() => {
          this.loading1= false;
        })
    },
    link_deta() {
      this.open= true;
    },
    // 返回首页
    return_index() {
      this.$router.replace({
        path: "/index"
      })
    }
  },
  components: {
    AddProduct
  }
}
</script>

<style lang="less" scoped>
    @import "../../../style/Make/MakeItem";
</style>
